<script setup>
import { ref } from "vue";
import ViewImage from "@/components/ViewImage.vue";
import moment from "moment";

const props = defineProps({
  documents: {
    type: Array,
    default: () => [],
  },
  stopDate: {
    type: String,
    default: "",
  },
});

const lightbox = ref(null);

function getDocumentLabel(url) {
  const lower = String(url || "").toLowerCase();
  let  name = 'FOTO';
  if (lower.includes("firma") || lower.includes("signature")) 
    name =  "FIRMA";
  return  name;
}

function getDocumentDescription(url) {
  const label = getDocumentLabel(url);
  const date = String(props.stopDate || "").trim();
  if (!date) return label;
  return `${label} · ${moment(date).format("DD/MM/YYYY")}`;
}

function openLightbox(url) {
  lightbox.value = { url, label: getDocumentDescription(url) };
}

function closeLightbox() {
  lightbox.value = null;
}
</script>

<template>
  <div class="stop-documents-tab">
    <div v-if="documents.length === 0" class="stop-documents-empty text-sm">
      Sin evidencias
    </div>

    <div v-else class="stop-documents-gallery">
      <view-image
        v-for="(docUrl, index) in documents"
        :key="`${docUrl}-${index}`"
        :url="docUrl"
        :label="getDocumentDescription(docUrl)"
        @view="openLightbox(docUrl)"
      />
    </div>

    <teleport to="body">
      <div v-if="lightbox" class="stop-lightbox-overlay" @click="closeLightbox">
        <div class="stop-lightbox-box" @click.stop>
          <button class="stop-lightbox-close" @click="closeLightbox">
            <i class="fas fa-times"></i>
          </button>
          <img :src="lightbox.url" :alt="lightbox.label" class="stop-lightbox-img" />
          <p class="stop-lightbox-caption">{{ lightbox.label }}</p>
        </div>
      </div>
    </teleport>
  </div>
</template>

<style scoped>
.stop-documents-tab {
  margin-top: 0.75rem;
}

.stop-documents-empty {
  color: var(--color-text-secondary);
  padding: 0.5rem 0.25rem;
  text-align: center;
}

.stop-documents-gallery {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}
</style>

<style>
.stop-lightbox-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.stop-lightbox-box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 90vw;
  max-height: 90vh;
}

.stop-lightbox-close {
  position: absolute;
  top: -2.25rem;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 1.4rem;
  cursor: pointer;
  line-height: 1;
  padding: 0.25rem;
  opacity: 0.85;
  transition: opacity 0.15s;
}

.stop-lightbox-close:hover {
  opacity: 1;
}

.stop-lightbox-img {
  max-width: 90vw;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 6px;
  display: block;
}

.stop-lightbox-caption {
  margin-top: 0.65rem;
  color: #ffffff;
  font-size: 0.8rem;
  text-align: center;
  max-width: 80vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
